<app-breadcrumbs></app-breadcrumbs>
<div [cfaLoading]="loading">
  <button mat-raised-button color="primary" id="store-number-search-button" (click)="getItems()">
    <mat-icon>search</mat-icon>
  </button>
  <mat-form-field id="store-number-search-field" appearance="outline">
    <mat-label>Store Number</mat-label>
    <input matInput maxlength="5" minLength="5" [(ngModel)]="storeNumber" autofocus
      (keydown.enter)="getItems()"/>
  </mat-form-field>
</div>
<div class="card-wrapper">
  @if (lanInfo != null || lanError != null) {
    <mat-card>
      <mat-card-header>
        <mat-card-title>LAN (DNS)</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-divider></mat-divider>
        @if (lanError) {
          <p>{{lanError}}</p>
        } @else {
          <p><b>UNIT_POS_GW:</b> {{lanInfo["UNIT_POS_GW"]}}</p>
          <p><b>UNIT_PC_IP:</b> {{lanInfo["UNIT_PC_IP"]}}</p>
          <p><b>UNIT_BYOD_GW:</b> {{lanInfo["UNIT_BYOD_GW"]}}</p>
        }
      </mat-card-content>
    </mat-card>
  }
  @if (wanInfo != null || wanError != null) {
    <mat-card>
      <mat-card-header>
        <mat-card-title>WAN1 (Source of Truth)</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-divider></mat-divider>
        @if (wanError) {
          <p>{{wanError}}</p>
        } @else {
          <p><b>UNIT_WAN1_TYPE:</b> {{wanInfo["wan_type"]}}</p>
          <p><b>UNIT_WAN1_IP:</b> {{wanInfo["public_ip"]}}</p>
          <p><b>UNIT_WAN1_SubnetMask:</b> {{wanInfo["subnet_mask"]}}</p>
          <p><b>UNIT_WAN1_GW:</b> {{wanInfo["gateway_ip"]}}</p>
          <p><b>UNIT_WAN1_Speed_Duplex:</b> {{wanInfo["speedduplex"]}}</p>
          <!-- -1 means bandwidth is not set -->
          <p><b>UNIT_WAN1_Bandwidth:</b> {{wanInfo["bandwidth"] === "-1" ? "Not set" : wanInfo["bandwidth"]}}</p>
        }
      </mat-card-content>
    </mat-card>
  }
</div>
